/** Enlaces de checkout de Novar Recursos por plan. */
export const CHECKOUT_URLS = {
  /** MegaPack Cocina Para Diabéticos — $19.990 ARS */
  megapack: 'https://www.novarecursos.online/cart/45116950085840:1',
  /** MegaPack + Kit Control Total — $27.990 ARS */
  kitControlTotal: 'https://www.novarecursos.online/cart/45116950118608:1',
} as const
